import { Injectable, Type } from "@angular/core";

import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  FnTransferableArg,
  UiArguments,
} from "shared/provider-webworker";

import { ReplicaBlotterLookupService } from "../../impl/ReplicaBlotterLookupService";
import { IBasePrimeDependent } from "../../IBasePrimeDependent";
import { IInterventionDataPromiseLookupService } from "../IInterventionDataPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class InterventionDataReplicaLookupService
  extends ReplicaBlotterLookupService<string, CubiqTS.InterventionEventImpl>
  implements IInterventionDataPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.InterventionEventImpl,
      "InterventionEventImpl",
      CubiqTS.InterventionEventImpl,
    );
  }

  startUpdates(): void {}

  getInterventionData(id: string): Promise<CubiqTS.InterventionEventImpl> {
    let request = new UiArguments("getInterventionData");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  protected getModelUpdateEventType(): Type<CubiqTS.ConcreteEncodable> {
    return CubiqTS.InterventionEventImpl;
  }

  addOrderEntryReference(ref: string): Promise<boolean> {
    let request = new UiArguments("addOrderEntryReference");
    let arg1 = new FnArg(ref, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  removeOrderEntryReference(ref: string): Promise<boolean> {
    let request = new UiArguments("removeOrderEntryReference");
    let arg1 = new FnArg(ref, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  hasOrderEntryReference(ref: string): Promise<boolean> {
    let request = new UiArguments("hasOrderEntryReference");
    let arg1 = new FnArg(ref, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
